import React from 'react';

function PageHeader({title}){
  return(
<div className='m-5 text-center'>
<h1  style={{margin:'125px 0px'}}>{title}</h1>
</div>
  )
}

export default PageHeader